/* SAFA · DA Terre */
(function () {
  'use strict';
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var desk = window.matchMedia ? matchMedia('(min-width: 990px)') : { matches: true };
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function seg(p, a, b) { return clamp((p - a) / (b - a), 0, 1); }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  var tasks = [];
  var ticking = false;
  function loop() { ticking = false; for (var i = 0; i < tasks.length; i++) tasks[i](); }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(loop); } }

  /* En-tête */
  function header() {
    var h = document.querySelector('[data-t-header]');
    if (!h) return;
    var t = h.querySelector('[data-t-burger]');
    tasks.push(function () { h.classList.toggle('is-scrolled', window.scrollY > 40); });
    function close() { h.classList.remove('is-open'); document.documentElement.classList.remove('t-nav-open'); if (t) t.setAttribute('aria-expanded', 'false'); }
    if (t) t.addEventListener('click', function () {
      var o = !h.classList.contains('is-open');
      h.classList.toggle('is-open', o); document.documentElement.classList.toggle('t-nav-open', o); t.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
    $$('.t-nav a', h).forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && h.classList.contains('is-open')) { close(); if (t) t.focus(); } });
  }

  /* Bandeau */
  function announce() {
    var items = $$('[data-t-ann] .t-ann__item');
    if (items.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4000);
  }

  /* Vidéos automatiques */
  function autoplay() {
    $$('[data-t-autoplay]').forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      function go() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { if (e[0].isIntersecting) go(); else v.pause(); }, { rootMargin: '120px' }).observe(v); else go();
      ['touchstart', 'click'].forEach(function (ev) { window.addEventListener(ev, function h() { if (v.paused && v.getBoundingClientRect().top < innerHeight) go(); window.removeEventListener(ev, h); }, { passive: true }); });
    });
  }

  /* Apparitions + compteurs */
  function reveal() {
    var els = $$('[data-t-in]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px', threshold: .05 });
    els.forEach(function (e) { io.observe(e); });
  }
  function counters() {
    var els = $$('[data-t-count]');
    if (!els.length) return;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-t-count')); var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      var pre = el.getAttribute('data-pre') || ''; var t0 = null;
      function fmt(v) { return pre + v.toFixed(dec).replace('.', ','); }
      if (reduce) { el.textContent = fmt(to); return; }
      function step(ts) { if (!t0) t0 = ts; var k = clamp((ts - t0) / 1600, 0, 1); el.textContent = fmt(to * ease(k)); if (k < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }); }, { threshold: .4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Parallaxe héro + inclinaison souris */
  function hero() {
    var root = document.querySelector('[data-t-hero]');
    if (!root || reduce) return;
    var par = $$('[data-t-par]', root);
    tasks.push(function () {
      var y = window.scrollY; if (y > innerHeight * 1.2) return;
      par.forEach(function (el) { el.style.translate = '0 ' + (y * parseFloat(el.getAttribute('data-t-par'))).toFixed(1) + 'px'; });
    });
    var prod = root.querySelector('.t-hero__product');
    if (prod && desk.matches) root.addEventListener('pointermove', function (e) {
      var r = root.getBoundingClientRect(); var x = (e.clientX - r.left) / r.width - .5; var yy = (e.clientY - r.top) / r.height - .5;
      prod.style.rotate = (x * 6).toFixed(2) + 'deg'; prod.style.scale = (1 + Math.abs(x) * .03).toFixed(3);
      root.style.setProperty('--mx', x.toFixed(3)); root.style.setProperty('--my', yy.toFixed(3));
    });
  }

  /* Manifeste : les mots s'allument */
  function words() {
    $$('[data-t-words]').forEach(function (box) {
      function wrap(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) frag.appendChild(document.createTextNode(part));
              else { var s = document.createElement('span'); s.className = 'w'; s.textContent = part; frag.appendChild(s); }
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.classList.contains('t-inline')) { n.classList.add('w'); }
          else if (n.nodeType === 1) wrap(n);
        });
      }
      wrap(box);
      var ws = $$('.w', box);
      if (reduce) { ws.forEach(function (w) { w.classList.add('on'); }); return; }
      tasks.push(function () {
        var r = box.getBoundingClientRect(); var vh = innerHeight;
        var p = seg(vh * .85 - r.top, 0, r.height + vh * .35);
        var n = Math.round(p * ws.length);
        for (var i = 0; i < ws.length; i++) ws[i].classList.toggle('on', i < n);
      });
    });
  }

  /* Pot qui s'ouvre au scroll */
  function potReveal() {
    $$('[data-t-reveal]').forEach(function (sec) {
      var closed = sec.querySelector('.t-reveal__closed'), jar = sec.querySelector('.t-reveal__jar'), lid = sec.querySelector('.t-reveal__lid');
      var fils = $$('.t-reveal__fil', sec), steps = $$('.t-reveal__step', sec), dots = $$('.t-reveal__dots i', sec), cur = sec.querySelector('[data-t-cur]');
      var glow = sec.querySelector('.t-reveal__glow'), giant = sec.querySelector('.t-reveal__giant');
      var last = -1;
      function render(p) {
        var open = ease(seg(p, .1, .2));
        var lift = ease(seg(p, .2, .52));
        var burst = ease(seg(p, .42, .78));
        var spin = seg(p, 0, 1);
        if (closed) closed.style.opacity = (1 - open).toFixed(3);
        if (jar) { jar.style.opacity = open.toFixed(3); jar.style.transform = 'translateY(' + (lift * 6).toFixed(2) + '%) rotate(' + (-6 * lift + 3 * burst).toFixed(2) + 'deg) scale(' + (1 - .04 * lift).toFixed(3) + ')'; }
        if (closed) closed.style.transform = 'rotate(' + (-4 + 4 * open).toFixed(2) + 'deg) scale(' + (1 + .02 * spin).toFixed(3) + ')';
        if (lid) { lid.style.opacity = open.toFixed(3); lid.style.transform = 'translate(' + (lift * 22).toFixed(2) + '%,' + (-lift * 62).toFixed(2) + '%) rotate(' + (lift * 22).toFixed(2) + 'deg) scale(' + (1 + lift * .1).toFixed(3) + ')'; }
        fils.forEach(function (f, i) {
          var dir = i === 0 ? -1 : i === 1 ? 1 : 0; var b = burst;
          f.style.opacity = (b * (i === 2 ? .9 : 1)).toFixed(3);
          f.style.transform = 'translate(' + (dir * b * 85).toFixed(1) + '%,' + (-b * (i === 2 ? 95 : 40)).toFixed(1) + '%) rotate(' + (dir * b * 35 + (i === 2 ? b * 20 : 0)).toFixed(1) + 'deg) scale(' + (.4 + b * .7).toFixed(3) + ')';
        });
        if (glow) glow.style.setProperty('--glow', (.35 + burst * .65).toFixed(3));
        if (giant) giant.style.transform = 'translateY(-50%) translateX(' + ((.5 - p) * 12).toFixed(2) + '%)';
        var idx = clamp(Math.floor(p * steps.length * .999), 0, steps.length - 1);
        if (idx !== last) {
          steps.forEach(function (s, i) { s.classList.toggle('is-on', i === idx); });
          dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
          if (cur) cur.textContent = ('0' + (idx + 1)).slice(-2);
          last = idx;
        }
      }
      if (reduce) { render(.6); return; }
      tasks.push(function () {
        var r = sec.getBoundingClientRect(); var total = r.height - innerHeight;
        if (r.bottom < -100 || r.top > innerHeight + 100) return;
        render(clamp(-r.top / total, 0, 1));
      });
    });
  }

  /* Origine : défilement horizontal épinglé */
  function hscroll() {
    $$('[data-t-hscroll]').forEach(function (sec) {
      var track = sec.querySelector('.t-origin__track');
      if (!track || reduce) return;
      var dist = 0;
      function setup() {
        if (desk.matches) {
          sec.classList.add('is-pinned');
          track.style.transform = '';
          dist = Math.max(0, track.scrollWidth - innerWidth);
          sec.style.height = (innerHeight + dist) + 'px';
        } else { sec.classList.remove('is-pinned'); sec.style.height = ''; track.style.transform = ''; dist = 0; }
      }
      setup();
      window.addEventListener('resize', setup);
      window.addEventListener('load', setup);
      tasks.push(function () {
        if (!dist) return;
        var r = sec.getBoundingClientRect(); var p = clamp(-r.top / (r.height - innerHeight), 0, 1);
        track.style.transform = 'translate3d(' + (-p * dist).toFixed(1) + 'px,0,0)';
      });
    });
  }

  /* Galerie fiche produit */
  function gallery() {
    $$('[data-t-gallery]').forEach(function (g) {
      var slides = $$('.t-slide', g), dots = $$('.t-pdp__dots button', g), thumbs = $$('[data-t-thumb]', g.parentNode), curL = g.querySelector('[data-t-cur]');
      var i = 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var on = k === i; s.classList.toggle('is-active', on);
          var v = s.querySelector('video'); if (v) { if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); }
        });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        thumbs.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (curL) curL.textContent = ('0' + (i + 1)).slice(-2);
      }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      thumbs.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var pv = g.querySelector('[data-t-prev]'), nx = g.querySelector('[data-t-next]');
      if (pv) pv.addEventListener('click', function () { go(i - 1); });
      if (nx) nx.addEventListener('click', function () { go(i + 1); });
      var x0 = null;
      g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      g.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    });
  }

  /* Ancres */
  function anchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1); var el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 84, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* Panier : ligne offerte */
  function freeLines() {
    document.addEventListener('herat:cart-rendered', function (e) {
      var cart = e.detail && e.detail.cart; if (!cart || !cart.items) return;
      var fmt = (window.theme && window.theme.moneyFormat) || '{{amount}} €';
      cart.items.forEach(function (it) {
        if (it.final_line_price !== 0 || !(it.original_line_price > 0)) return;
        var line = document.querySelector('#CartDrawer .cd__line[data-key="' + it.key + '"]'); if (!line) return;
        var pr = line.querySelector('.cd__line-price'); if (!pr) return;
        var amt = (it.original_line_price / 100).toFixed(2).replace('.', ',');
        line.classList.add('cd__line--free');
        pr.innerHTML = '<span class="t-cd__free">Offert</span><s>' + fmt.replace(/\{\{\s*\w+\s*\}\}/, amt) + '</s>';
      });
    });
  }

  function init() {
    header(); announce(); autoplay(); reveal(); counters(); hero(); words(); potReveal(); hscroll(); gallery(); anchors(); freeLines();
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    req();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { reveal(); counters(); });
})();